import cn from "classnames";
import { t } from "i18next";
import { Controller } from "react-hook-form";
import { FormField, RadioButton } from "ui";

import { InfluencerCodeKindFieldProps } from "../CouponForm.types";

import styles from "../CouponForm.module.scss";

const OPTIONS = [
  {
    value: "permanent",
    label: "Permanent code",
    description:
      "The influencer's one code, valid indefinitely. A first-time customer who uses it is linked to the influencer for life, so every later order they place earns a commission."
  },
  {
    value: "campaign",
    label: "Limited-time code",
    description:
      "Runs for the dates set below and then expires. It discounts the order and pays a commission on it, but links nobody to the influencer."
  }
];

/**
 * Two very different things wear the same shape here, and the backend cannot
 * tell them apart on its own — hence a radio pair rather than a checkbox: a
 * campaign code is not obviously "the box left unticked".
 */
const InfluencerCodeKindField = ({
  control
}: InfluencerCodeKindFieldProps) => {
  return (
    <Controller
      control={control}
      name="isPermanentInfluencerCode"
      render={({ field: { value, onChange } }) => (
        <FormField label={t("Code type")}>
          <div className={styles.form_codeKind}>
            {OPTIONS.map((option) => {
              const isChecked =
                option.value === "permanent" ? !!value : !value;

              return (
                <div
                  key={option.value}
                  className={cn(styles.form_codeKind_option, {
                    [styles.form_codeKind_option__active]: isChecked
                  })}
                  onClick={() => onChange(option.value === "permanent")}
                >
                  <RadioButton
                    name="influencerCodeKind"
                    value={option.value}
                    label={option.label}
                    checked={isChecked}
                    onChange={(event) => {
                      if (event.currentTarget.checked) {
                        onChange(option.value === "permanent");
                      }
                    }}
                  />

                  <span className={styles.form_codeKind_description}>
                    {t(option.description)}
                  </span>
                </div>
              );
            })}
          </div>
        </FormField>
      )}
    />
  );
};

export default InfluencerCodeKindField;
